import type { CategoryPlpStyleProps } from './banner-category-plp'

export const getCustomStylesText = (styles?: CategoryPlpStyleProps) => {
  return {
    ...(styles?.textColor ? { color: styles?.textColor } : ''),
  }
}

export const getCustomStylesImage = (styles?: CategoryPlpStyleProps) => {
  return {
    ...(styles?.borderColor
      ? { border: `1px solid ${styles?.borderColor}` }
      : ''),
  }
}
